<ng-template ngIf="data">
    <ng-template [ngIf]="data.templateRef" [ngIfElse]="dynamicContent">
        <ng-container [ngTemplateOutlet]="data.templateRef"></ng-container>
    </ng-template>
    <ng-template #dynamicContent></ng-template>
</ng-template>
